import React, { useCallback, useEffect, useState } from "react";
import Modal from "../../elements/Modal";
import Input from "../../form/Input";
import Button from "../../form/Button";
import useForm from "../../../hooks/useForm";
import { toast } from "react-toastify";
import Indentification from "../../elements/Indentification";
import { initialsValue } from "../../../helpers";
import Loader from "../../common/Loader";
import SyncingLoader from "../../loaders/SyncingLoader";
import moment from "moment";
import { useSsoLogin } from "../../../Context/SsoLoginContext";
import {
  NINEBOX_API_URL,
  NINEBOX_BASE_URL,
  SUCCESSION_API_URL,
  SUCCESSION_BASE_URL,
} from "../../../config/host";
import { syncGenarateToken, syncRecord } from "../../../services/SsoService";
import axios from "axios";
import { useSelector } from "react-redux";
import { chartDetails } from "../../../services/frontService/ChartService";

export default function SyncFromChart({
  isOpen,
  setIsOpen = () => {},
  details,
  selectedSite,
}) {
  const profile = useSelector((state) => state?.profile?.data);
  const [syncDetails, setSyncDetails] = useState({});
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (details?._id) {
      setLoaded(true);
      chartDetails({ id: details?._id }).then((res) => {
        setSyncDetails({
          loading: false,
          data: res?.status === 200 ? res.data : {},
        });
        setLoaded(false);
      });
    }
  }, [details?._id]);

  const {
    enabledConfirmationPopup,
    setEnabledConfirmationPopup,
    dropdownData,
    setSelectedWebsite,
    setSelectedWebsite: gotoWebsite,
    getGenarateToken,
  } = useSsoLogin();

  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (syncDetails) {
      setUserDetails(syncDetails?.data?.userDetails);
    }
  }, [syncDetails]);

  const matchingWebsiteInfo = syncDetails?.data?.userDetails?.websiteInfo?.find(
    (info) => info?.code === selectedSite
  );
  const onSubmit = (selectedSite) => {
    if (selectedSite === "nineBoxNow") {
      getGenarateToken(NINEBOX_BASE_URL, NINEBOX_API_URL, matchingWebsiteInfo?.userId);
    } else if (selectedSite === "successionNow") {
      getGenarateToken(
        SUCCESSION_BASE_URL,
        SUCCESSION_API_URL,
        matchingWebsiteInfo?.userId
      );
    }
  };
  const getGenarateSyncRecord = async (syncRecordData) => {
    try {
      const res = await syncRecord({
        type: "user",
        userId: syncRecordData?.userId,
        id: syncRecordData?.id,
        code: syncRecordData?.code,
      });
      if (res?.status === 200) {
        if (details?._id) {
          setLoaded(true);
          chartDetails({ id: details._id })
            .then((res) => {
              setSyncDetails({
                loading: false,
                data: res?.status === 200 ? res?.data : {},
              });
            })
            .finally(() => {
              setLoaded(false);
            });
        }
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
      toast.error("Somthing went wrong !!!");
    }
  };
  const syncEmployee = async (url, headersToken) => {
    try {
      const path = url;
      const currentEmployee = syncDetails?.data?.userDetails;
      const payload = {
        companyEmail: profile?.email,
        name: currentEmployee?.firstName + " " + currentEmployee?.lastName,
        email: currentEmployee?.email,
        userId: currentEmployee?._id,
        ...(currentEmployee?.positionDetails?.title
          ? { position_details: currentEmployee?.positionDetails }
          : {}),
        role_details:
          Array.isArray(currentEmployee?.roleDetail) &&
          currentEmployee?.roleDetail?.length > 0
            ? currentEmployee?.roleDetail
            : [],
        code: "orgChart",
        image: currentEmployee?.image?.url,
        passkey: currentEmployee?.passkey || null,
        status: currentEmployee?.status,
        emailVerified: currentEmployee?.emailVerified,
      };

      try {
        const res = await axios.post(path, payload, {
          headers: {
            Authorization: `Bearer ${headersToken}`,
            "Content-Type": "application/json",
          },
        });
        if (res?.data?.status === 200) {
          const syncRecordData = {
            userId: res?.data?.data?.data,
            id: details?.userDetails?._id,
            code: selectedSite,
          };
          getGenarateSyncRecord(syncRecordData);
        } else {
          console.log(`Failed to sync: ${details?.userDetails?.name}`);
        }
      } catch (err) {
        console.error(
          `Error syncing employee: ${details?.userDetails?.name}`,
          err
        );

        if (err.response) {
          console.error("Server error:", err.response.data);
          toast.error(
            `Error: ${err.response.data.message || "Server error occurred."}`
          );
        } else if (err.request) {
          console.error("No response received:", err.request);
          toast.error("Network error. Please try again later.");
        } else {
          console.error("Unexpected error:", err.message);
          toast.error(`Unexpected error: ${err.message}`);
        }
      }
    } catch (err) {
      console.error("Critical error during the sync process:", err);
      toast.error("A critical error occurred. Please try again later.");
    }
  };

  const getGenarateTokenEmployee = async (DOMAIN, API_URL = "") => {
    try {
      const res = await syncGenarateToken({
        domain: DOMAIN,
      });
      if (res?.status === 200) {
        const url = API_URL + "sync-employees";
        const headersToken = res?.data;
        syncEmployee(url, headersToken);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
      toast.error("Somthing went wrong !!!");
    }
  };
  return (
    <Modal
      title={"Details"}
      size="lg"
      open={isOpen}
      onClose={() => {
        setLoading(false);
        setIsOpen(false);
      }}
      modaltitleClasses={"!text-slate-200 text-[15px]"}
      headerClass={"!bg-black dark:!bg-slate-800 !rounded-t-lg !text-white dark:!text-slate-400"}
      childrenClasses={"!pb-8 !rounded-b-lg"}
    >
      <form>
        {!loaded ? (
          <div className="relative flex items-center space-x-2 col-span-12">
            <div className="bg-white dark:bg-slate-600 rounded-md border border-slate-200 dark:border-slate-400 py-4 px-4 flex  gap-2 w-full">
              <div className="flex justify-start items-start py-2 flex-shrink-0">
                <div className="flex items-center justify-between"></div>
              </div>

              <Indentification
                initial={initialsValue(
                  userDetails?.firstName + " " + userDetails?.lastName
                )}
                image={userDetails?.image?.url}
                alt={userDetails?.firstName}
                fill={true}
                className={""}
                size={"lg"}
                initialClass={" !text-sm"}
              />
              <div className="space-y-px flex-shrink">
                <h3 className="text-sm font-semibold text-orange-500 capitalize !leading-none">
                  <span>
                    {userDetails?.firstName + " " + userDetails?.lastName ||
                      "N/A"}
                  </span>
                  <small className="text-slate-600 dark:text-slate-300 capitalize text-xs font-medium block">
                    {/* {user?.roleDetails &&
                                          Array.isArray(
                                            user?.roleDetails
                                          ) &&
                                          user?.roleDetails.length > 0
                                            ? user?.roleDetails
                                                .map((role) => role?.name)
                                                .join(", ")
                                            : "N/A"} */}
                    {userDetails?.roleDetails &&
                    Array.isArray(userDetails?.roleDetails) &&
                    userDetails?.roleDetails?.find(
                      (item) => item?.code === "COMPANY-ADMINISTRATOR"
                    )
                      ? "Administrator"
                      : "Employee"}
                  </small>
                </h3>
                <div className="text-xs text-gray-500 dark:text-slate-200 flex items-center gap-2 break-all">
                  <span>{userDetails?.email || "N/A"}</span>
                </div>
              </div>
              {userDetails?.syncingStatus === "processing" && (
                <div className="flex flex-col items-center ml-auto flex-shrink-0">
                  <Loader className={"scale-50"} />
                  <SyncingLoader className={"!text-xs"} />
                </div>
              )}
              {userDetails?.syncingStatus === "success" && (
                <div className="flex flex-col items-center ml-auto flex-shrink-0">
                  <div className="w-8 h-8">
                    {/* <img src={syncSuccess} alt="syncSuccess" /> */}
                  </div>
                  <div className="flex text-center justify-center items-center text-xs font-semibold text-green-600">
                    {"Sync Finished"}
                  </div>
                </div>
              )}
              {userDetails?.syncingStatus === "failed" && (
                <div className="flex flex-col items-center ml-auto flex-shrink-0">
                  <div className="w-8 h-8">
                    {/* <img src={syncFailed} alt="syncFailed" /> */}
                  </div>
                  <div className="flex text-center justify-center items-center text-xs font-semibold text-rose-600">
                    {"Sync Failed"}
                  </div>
                </div>
              )}
              {matchingWebsiteInfo ? (
                <div className="flex flex-col items-end ml-auto flex-shrink-0">
                  <div className="w-8 h-8">
                    <i className="far fa-sync"></i>
                  </div>
                  <div className="flex text-right flex-col justify-center items-end text-[11px] font-semibold text-slate-400 !leading-none">
                    Last Sync
                    <span className="text-slate-500 font-bold">
                      {moment(matchingWebsiteInfo?.updatedAt).format("ll")}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-end ml-auto flex-shrink-0"></div>
              )}
              {matchingWebsiteInfo ? (
                <Button
                  buttonClasses={
                    "!bg-orange-500 !border-orange-500 hover:!bg-orange-500/80 !rounded-lg"
                  }
                  buttonLabelClasses=""
                  buttonType={"button"}
                  buttonIcon={
                    loading
                      ? "fa-light fa-spinner fa-spin"
                      : "fa-solid fa-arrow-right-to-bracket"
                  }
                  buttonIconPosition={"left"}
                  buttonLabel={`Go to ${
                    selectedSite === "nineBoxNow" ? "9BoxNow" : "SuccesionNow"
                  }`}
                  buttonFunction={() => onSubmit(selectedSite)}
                  buttonHasLink={false}
                  buttonDisabled={loading}
                />
              ) : (
                <div className="flex items-center">
                  <Button
                    buttonLabel={`Sync Employee`}
                    buttonIcon={"fa-solid fa-rotate"}
                    buttonIconPosition={"left"}
                    buttonClasses={"!bg-orange-500 !text-white"}
                    buttonLabelClasses={"!text-white"}
                    buttonFunction={() => {
                      if (selectedSite === "successionNow") {
                        getGenarateTokenEmployee(
                          SUCCESSION_BASE_URL,
                          SUCCESSION_API_URL
                        );
                      } else if (selectedSite === "nineBoxNow") {
                        getGenarateTokenEmployee(
                          NINEBOX_BASE_URL,
                          NINEBOX_API_URL
                        );
                      } else {
                        toast.error("Please Select a Website For Syncinggg");
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="relative flex  items-center justify-center">
            <SyncingLoader />
          </div>
        )}
      </form>
    </Modal>
  );
}
